import { FC } from 'react'
import { EmbedGuard } from 'components/higher-order/EmbedGuard/EmbedGuard'

interface Props {
  component: FC
}

export const EmbedPurchaseFlowGuard: FC<Props> = ({ component }) => (
  <EmbedGuard component={component} entryEvent='enters_embed_purchase_flow' componentName='EmbedPurchaseFlowGuard' />
)
